import axios from '@plugins/axios'
import getSecret from '@utils/get-secret'

let serverUrl = getSecret('SERVER_URL')

function sumQuantityItems(items){
  let quantity = 0
  for (let i = 0; i < items.length; i++) {
    const item = items[i];
    let subquantity = 0
    if ('batchs' in item){
      for (let b = 0; b < item.batchs.length; b++) {
        subquantity += item.batchs[b].quantity;
      }
      quantity += subquantity
    } else{
      if(item.item){
        if('batchs' in item.item){
          for (let b = 0; b < item.item.batchs.length; b++) {
            subquantity += item.item.batchs[b].quantity;
          }
          quantity += subquantity
        }
      }
      if(item.quantity)quantity +=item.quantity
    }
  }
  return quantity
}
function sumQuantityOwnItems(items){
  let quantity = 0
  for (let i = 0; i < items.length; i++) {
    const item = items[i];
    let subquantity = 0
    if ('batchs' in item){
      for (let b = 0; b < item.batchs.length; b++) {
        subquantity += item.batchs[b].count;
      }
      quantity += subquantity
    } else{
      if(item.item){
        if('batchs' in item.item){
          for (let b = 0; b < item.item.batchs.length; b++) {
            subquantity += item.item.batchs[b].count;
          }
          quantity += subquantity
        }
      }
      if(item.quantity)quantity +=item.quantity
    }
  }
  return quantity
}

const removeBatchFromInventory = async(_item, _type, _subtype) => {
  return
  console.warn('removeBatchFromInventory', _item, _type, _subtype, "serial:", _item.serial)
  if (Object.keys(state.inventory).length > 0){
    let _inve_item = state.inventory.find( (i) => i.id_ext1 === _item.item.id_ext1)
    if (!_inve_item) return
    _inve_item.batchs.forEach(batch => {
      if (batch.batch === _item.batch){
        if (_type === 'serial' && batch.serials.includes(_item.serial)){
          if (batch.serials.length === 1 && _inve_item.batchs.length === 1){
            // un solo serial, se elimina el lote completo del inventario, porque pasó a pendiente (completamente)
            state.inventory = state.inventory.filter(x => x.id_ext1 !== _item.item.id_ext1)
            state.total_products_quantity = sumQuantityItems(state.inventory)
            saveState('total_products_quantity', state.total_products_quantity)
            console.warn("UPDATED! 1", state.total_products_quantity)
          } else if (batch.serials.length > 1){
            const index = batch.serials.indexOf(_item.serial)
            if (index > -1) {
              batch.serials.splice(index, 1)
              batch.assurance.splice(index, 1)
              batch.quantity -= 1
              state.total_products_quantity = sumQuantityItems(state.inventory)
              saveState('total_products_quantity', state.total_products_quantity)
              console.warn("UPDATED! 2", state.total_products_quantity)
            }
          }
        } else if(_type === 'batch'){
          console.warn("NOT UPDATED!")
        } 
      }
    });

    
  }
}



export const state = {
  warehouse_i: getSavedState('warehouse_i'),
  own_warehouse_i: getSavedState('own_warehouse_i'),
  ubication_i: getSavedState('ubication_i'),
  inventory: getSavedState('inventory'),
  own_inventory: getSavedState('own_inventory'),
  total_products: getSavedState('total_products'),
  own_total_products: getSavedState('own_total_products'),
  total_products_quantity: getSavedState('total_products_quantity'),
  own_total_products_quantity: getSavedState('own_total_products_quantity'),
  stock: getSavedState('stock'),
  own_stock: getSavedState('own_stock'),
  total_stock: getSavedState('total_stock'),
  own_total_stock: getSavedState('own_total_stock'),
  total_stock_quantity: getSavedState('total_stock_quantity'),
  own_total_stock_quantity: getSavedState('own_total_stock_quantity'),
  spent: getSavedState('spent'),
  total_spent: getSavedState('total_spent'),
  total_spent_quantity: getSavedState('total_spent_quantity'),
  pending: getSavedState('pending') ? getSavedState('pending') : [],
  own_pending: getSavedState('own_pending') ? getSavedState('own_pending') : [],
  total_pending: getSavedState('total_pending'),
  own_total_pending: getSavedState('own_total_pending'),
  total_pending_quantity: getSavedState('total_pending_quantity'),
  own_total_pending_quantity: getSavedState('own_total_pending_quantity'),
  pending_results: getSavedState('pending_results'),
  own_pending_results: getSavedState('own_pending_results'),
  loading_inventory: false,
  inventory_count_mode: getSavedState('inventory_count_mode') || false,
  own_inventory_count_mode: getSavedState('own_inventory_count_mode') || false,
  inventory_count_spent_products: getSavedState('inventory_count_spent_products') || false,
  own_inventory_count_spent_products: getSavedState('own_inventory_count_spent_products') || false,
  inventory_count_review: getSavedState('inventory_count_review') || false,
  own_inventory_count_review: getSavedState('own_inventory_count_review') || false,
  inventory_online_mode: getSavedState('inventory_online_mode') || false,
  own_inventory_online_mode: getSavedState('own_inventory_online_mode') || false,
}

export const getters = {
  warehouse_i: (state) => state.warehouse_i,
  own_warehouse_i: (state) => state.own_warehouse_i,
  ubication_i: (state) => state.ubication_i,
  inventory: (state) => state.inventory,
  own_inventory: (state) => state.own_inventory,
  total_products: (state) => state.total_products,
  own_total_products: (state) => state.own_total_products,
  total_products_quantity: (state) => state.total_products_quantity,
  own_total_products_quantity: (state) => state.own_total_products_quantity,
  stock: (state) => state.stock,
  own_stock: (state) => state.own_stock,
  total_stock: (state) => state.total_stock,
  own_total_stock: (state) => state.own_total_stock,
  total_stock_quantity: (state) => state.total_stock_quantity,
  own_total_stock_quantity: (state) => state.own_total_stock_quantity,
  spent: (state) => state.spent,
  total_spent: (state) => state.total_spent,
  total_spent_quantity: (state) => state.total_spent_quantity,
  pending: (state) => state.pending,
  own_pending: (state) => state.own_pending,
  total_pending: (state) => state.total_pending,
  own_total_pending: (state) => state.own_total_pending,
  total_pending_quantity: (state) => state.total_pending_quantity,
  own_total_pending_quantity: (state) => state.own_total_pending_quantity,
  pending_results: (state) => state.pending_results,
  own_pending_results: (state) => state.own_pending_results,
  loading_inventory: (state) => state.loading_inventory,
  inventory_count_mode: (state) => state.inventory_count_mode,
  own_inventory_count_mode: (state) => state.own_inventory_count_mode,
  inventory_count_spent_products: (state) => state.inventory_count_spent_products,
  own_inventory_count_spent_products: (state) => state.own_inventory_count_spent_products,
  inventory_count_review: (state) => state.inventory_count_review,
  own_inventory_count_review: (state) => state.own_inventory_count_review,
  inventory_online_mode: (state) => state.inventory_online_mode,
  own_inventory_online_mode: (state) => state.own_inventory_online_mode,
}

export const mutations = {
  SET_WAREHOUSE_I(state, warehouse_i) {
    state.warehouse_i = warehouse_i
    saveState('warehouse_i', warehouse_i)
  },
  SET_OWN_WAREHOUSE_I(state, own_warehouse_i) {
    state.own_warehouse_i = own_warehouse_i
    saveState('own_warehouse_i', own_warehouse_i)
  },
  CLEAR_WAREHOUSE_I(state) {
    state.warehouse_i = null
    saveState('warehouse_i', null)
  },
  CLEAR_OWN_WAREHOUSE_I(state) {
    state.own_warehouse_i = null
    saveState('own_warehouse_i', null)
  },
  SET_UBICATION_I(state, ubication_i) {
    state.ubication_i = ubication_i
    saveState('ubication_i', ubication_i)
  },
  CLEAR_UBICATION_I(state) {
    state.ubication_i = null
    saveState('ubication_i', null)
  },
  SET_INVENTORY(state, inventory) {
    state.inventory = inventory
    saveState('inventory', inventory)
  },
  SET_OWN_INVENTORY(state, own_inventory) {
    state.own_inventory = own_inventory
    saveState('own_inventory', own_inventory)
  },
  SET_TOTAL_PRODUCTS(state, total_products) {
    state.total_products = total_products
    saveState('total_products', total_products)
  },
  SET_OWN_TOTAL_PRODUCTS(state, own_total_products) {
    state.own_total_products = own_total_products
    saveState('own_total_products', own_total_products)
  },
  SET_TOTAL_PRODUCTS_QUANTITY(state, total_products_quantity) {
    state.total_products_quantity = total_products_quantity
    saveState('total_products_quantity', total_products_quantity)
  },
  SET_OWN_TOTAL_PRODUCTS_QUANTITY(state, own_total_products_quantity) {
    state.own_total_products_quantity = own_total_products_quantity
    saveState('own_total_products_quantity', own_total_products_quantity)
  },
  CLEAR_INVENTORY(state) {
    state.inventory = []
    saveState('inventory', state.inventory)
  },
  CLEAR_OWN_INVENTORY(state) {
    state.own_inventory = []
    saveState('own_inventory', state.own_inventory)
  },
  SET_STOCK(state, stock) {
    state.stock = stock
    saveState('stock', stock)
  },
  SET_OWN_STOCK(state, own_stock) {
    state.own_stock = own_stock
    saveState('own_stock', own_stock)
  },
  SET_TOTAL_STOCK(state, total_stock) {
    state.total_stock = total_stock
    saveState('total_stock', total_stock)
  },
  SET_OWN_TOTAL_STOCK(state, own_total_stock) {
    state.own_total_stock = own_total_stock
    saveState('own_total_stock', own_total_stock)
  },
  SET_TOTAL_STOCK_QUANTITY(state, total_stock_quantity) {
    state.total_stock_quantity = total_stock_quantity
    saveState('total_stock_quantity', total_stock_quantity)
  },
  SET_OWN_TOTAL_STOCK_QUANTITY(state, own_total_stock_quantity) {
    state.own_total_stock_quantity = own_total_stock_quantity
    saveState('own_total_stock_quantity', own_total_stock_quantity)
  },
  CLEAR_STOCK(state) {
    state.stock = []
    saveState('stock', state.stock)
  },
  CLEAR_OWN_STOCK(state) {
    state.own_stock = []
    saveState('own_stock', state.own_stock)
  },
  MOVE_INVENTORY_ITEM_TO_STOCK_BY_SERIAL(state, item ) { 
    console.log("🅿️ into MOVE_INVENTORY_ITEM_TO_STOCK_BY_SERIAL")
    /**
    Se pasa un item de inventory a stock por serial

    El parametro item contiene:
      - item.item       :   el item de inventory 
      - item.serial     :   el serial escogido
      - item.batch      :   el lote al que pertenece el serial
      - item.assurance  :   el index del serial al que pertenece la fecha de garantía

    NOTAS: 

    cuando se llama a esta mutation debe estar verificado que: el lote y serial existen dentro de inventory 

    dentro de batchs: [ {batch:'', serials:[], assurance: [], quantity:x }, ]

    item.item es el item dentro del state.inventory
    Si realizamos cambios en item.item se veran reflejados en state.inventory 

    */
    // * buscamos si el item con referencia y extension existe dentro del stock
    let item_stock = state.stock.find( (i) => i.reference == item.item.reference && i.id_ext1 == item.item.id_ext1)

    // ? preguntamos: ¿si el item ya fue creado (existe) dentro del stock?
    if (Boolean(item_stock)) {
      // ! El item existe, ya fue creado

      // * buscamos dentro de el item si existe el lote
      let lot = item_stock.batchs.find( (i) => i.batch == item.batch )

      // ? preguntamos: ¿si ya fue creado (existe) el lote?
      if (Boolean(lot)) {
        // ! El lote existe, ya fue creado

        // * agregamos el serial y la fecha de garantía al lote del item
        lot.serials.push(item.serial)
        lot.assurance.push(
          item.item.batchs.find( (l) => l.batch == lot.batch)
            .assurance.find( (a, index) => item.assurance == index)
          )
        lot.quantity++
      }
      else {
        // ! El lote no existe

        // * agregamos el lote con el serial y su fecha de garantía al item
        item_stock.batchs.push({
          batch: item.batch, 
          serials: [item.serial], 
          assurance: [
            item.item.batchs.find( (l) => l.batch == item.batch).assurance.find( (a, index) => item.assurance == index)
            ],
          quantity: 1
        })
      }
    }
    else {
      // ! El item no existe. No se ha creado

      //* copiamos el item con sus referencias. Filtramos y dejamos el lote con el serial escogido con su fecha de garantía
      item_stock = JSON.parse(JSON.stringify(item.item))      
      item_stock.batchs = item_stock.batchs.filter( (i) => i.batch == item.batch )
      item_stock.batchs.map( (i) => i.serials = i.serials.filter( (s) => s == item.serial  ) )
      item_stock.batchs.map( (i) => i.assurance = i.assurance.filter( (a, index) => index == item.assurance))
      item_stock.batchs.map( (i) => i.quantity = 1 )
      state.stock.push(item_stock)
      state.total_stock++
      saveState('total_stock', state.total_stock)
    }

    // * Una vez agregado el item con lote, serial y fecha de garantía, buscamos la referencia en inventory y la quitamos 
    let lot = item.item.batchs.find( (i) => i.batch == item.batch )
    if (Boolean(lot)) {
      lot.serials = lot.serials.filter( (s) => s != item.serial )
      lot.assurance = lot.assurance.filter( (a, index) => index != item.assurance )
      lot.quantity--
    }

    // * se filtran los items con 0 existencias
    state.inventory = state.inventory.filter( (i) => i.batchs.find( (c) => c.quantity > 0) )
    state.total_products = state.inventory.length 
    saveState('total_products', state.total_products)
    
    state.total_products_quantity = sumQuantityItems(state.inventory)
    saveState('total_products_quantity', state.total_products_quantity)
    
    state.total_stock_quantity = sumQuantityItems(state.stock)
    saveState('total_stock_quantity', state.total_stock_quantity)

    // * Guardamos cambios
    saveState('stock', state.stock)
    saveState('inventory', state.inventory)
    saveState('total_products', state.total_products)
  },

  MOVE_OWN_INVENTORY_ITEM_TO_OWN_STOCK_BY_SERIAL(state, item) { 
    console.log("🅿️ into MOVE_OWN_INVENTORY_ITEM_TO_OWN_STOCK_BY_SERIAL")
    let item_stock = null
    let item_inventory = null
    let lot = null
    if (Boolean(item.item)) {
      if(item.item.id_ext1){
        item_stock = state.own_stock.find( (i) => i.item.reference == item.item.reference && i.item.id_ext1 == item.item.id_ext1)
        item_inventory = state.own_inventory.find( (i) => i.reference == item.item.reference && i.id_ext1 == item.item.id_ext1)
      }

      if(item.item.id_ext){
        item_stock = state.own_stock.find( (i) => i.item.reference == item.item.reference && i.item.id_ext == item.item.id_ext)
        item_inventory = state.own_inventory.find( (i) => i.reference == item.item.reference && i.id_ext == item.item.id_ext)
      }

      if (Boolean(item_inventory)) {
        item_inventory.status = true;
      }
    }

    // ? preguntamos: ¿si el item ya fue creado (existe) dentro del stock?
    if (Boolean(item_stock)) {
      // ! El item existe, ya fue creado

      // * buscamos dentro de el item si existe el lote
      lot = item_stock.item.batchs.find( (i) => i.batch == item.batch )

      // ? preguntamos: ¿si ya fue creado (existe) el lote?
      if (Boolean(lot)) {
        // ! El lote existe, ya fue creado

        // * agregamos el serial y la fecha de garantía al lote del item
        if(!lot.serials.includes(item.serial))lot.serials.push(item.serial)
        if(lot.assurance.length>0) lot.assurance.push(
          item.item.batchs.find( (l) => l.batch == lot.batch)
            .assurance.find( (a, index) => item.assurance == index)
          )
        lot.count++
      }
      else {
        // ! El lote no existe

        // * agregamos el lote con el serial y su fecha de garantía al item
        item_stock.batchs.push({
          batch: item.batch, 
          serials: [item.serial], 
          assurance: [
            item.item.batchs.find( (l) => l.batch == item.batch).assurance.find( (a, index) => item.assurance == index)
            ],
          quantity: null,
          count:1
        })
      }
    }
    else {
      if(!item.item.id_ext1)item_stock = state.own_stock.find( (i) => i.item.reference == item.item.reference)
      if(Boolean(item_stock)){
        lot = item_stock.item.batchs.find( (i) => i.batch == item.batch )
        if (Boolean(lot)) {
          if(!lot.serials.includes(item.serial))lot.serials.push(item.serial)
          lot.count++
        }
      } else{

        item_stock = JSON.parse(JSON.stringify(item))   
        if(item_stock.assurance && item_stock.item.id_ext1){
          item_stock.item.batchs.map( (i) => i.serials = i.serials.filter( (s) => s == item.serial  ) )
          item_stock.item.batchs.map( (i) => i.assurance = i.assurance.filter( (a, index) => index == item.assurance))
          item_stock.item.batchs.map( (i) => i.count = 0)
          item_stock.item.batchs.forEach((batch) => {
            if (batch.serials.includes(item.serial)) {
              batch.count = 1;
            }
          });
        }
        if(item_stock.item.id_ext){
          item_stock.item.batchs.map( (i) => i.count = 0)
          item_stock.item.batchs.forEach((batch) => {
            if (batch.serials.includes(item.serial)) {
              batch.count = 1;
            } else if (batch.batch==item.serial) {
              batch.count = 1;
            }
          });
        }
        item_stock.user=JSON.parse(window.localStorage.getItem('auth.currentSession')).user.email

        state.own_stock.push(item_stock)
        state.own_total_stock++
      }
      saveState('own_total_stock', state.own_total_stock)
    }
    
    state.own_total_stock_quantity = sumQuantityOwnItems(state.own_stock)
    saveState('own_total_stock_quantity', state.own_total_stock_quantity)

    // * Guardamos cambios
    saveState('own_stock', state.own_stock)
    saveState('own_inventory', state.own_inventory)
  },

  MOVE_STOCK_ITEM_TO_INVENTORY_BY_SERIAL(state, item ) { 
    console.log("🅿️ into MOVE_STOCK_ITEM_TO_INVENTORY_BY_SERIAL")
    let item_inventory = state.inventory.find( (i) => i.reference == item.item.reference && i.id_ext1 == item.item.id_ext1)
    if (Boolean(item_inventory)) {
      let lot = item_inventory.batchs.find( (i) => i.batch == item.batch )
      if (Boolean(lot)) {
        lot.serials.push(item.serial)
        lot.assurance.push(
          item.item.batchs.find( (l) => l.batch == lot.batch)
            .assurance.find( (a, index) => item.assurance == index)
          )
        lot.quantity++
      }
      else
        item_inventory.batchs.push({batch: item.batch, serials: [item.serial], assurance: [ item.item.batchs.find( (l) => l.batch == item.batch).assurance.find( (a, index) => item.assurance == index) ], quantity: 1})
    }
    else {
      item_inventory = JSON.parse(JSON.stringify(item.item))      
      item_inventory.batchs = item_inventory.batchs.filter( (i) => i.batch == item.batch )
      item_inventory.batchs.map( (i) => i.serials = i.serials.filter( (s) => s == item.serial  ) )
      item_inventory.batchs.map( (i) => i.assurance = i.assurance.filter( (a, index) => index == item.assurance ) )
      item_inventory.batchs.map( (i) => i.quantity = 1 )
      state.inventory.push(item_inventory)
      state.total_products++
      saveState('total_products', state.total_products)
    }
    let lot = item.item.batchs.find( (i) => i.batch == item.batch )
      if (Boolean(lot)) {
        lot.serials = lot.serials.filter( (s) => s != item.serial )
        lot.assurance = lot.assurance.filter( (a, index) => index != item.assurance )
        lot.quantity--
      }

    state.stock = state.stock.filter( (i) => i.batchs.find( (c) => c.quantity > 0) )
    state.total_stock = state.stock.length 

    saveState('stock', state.stock)
    saveState('total_stock', state.total_stock)

    state.total_stock_quantity = sumQuantityItems(state.stock)
    saveState('total_stock_quantity', state.total_stock_quantity)

    state.total_products_quantity = sumQuantityItems(state.inventory)
    saveState('total_products_quantity', state.total_products_quantity)

    saveState('inventory', state.inventory)
  },
  MOVE_OWN_STOCK_ITEM_TO_OWN_INVENTORY_BY_SERIAL(state, item ) { 
    state.own_stock.splice(item.index, 1);

    state.own_total_stock = state.own_stock.length 

    saveState('own_stock', state.own_stock)
    saveState('own_total_stock', state.own_total_stock)

    state.own_total_stock_quantity = sumQuantityOwnItems(state.own_stock)
    saveState('own_total_stock_quantity', state.own_total_stock_quantity)
  },

  MOVE_INVENTORY_ITEM_TO_STOCK_BY_LOTE(state, item ) { 
    console.log("🅿️ into MOVE_INVENTORY_ITEM_TO_STOCK_BY_LOTE")
    // se pasa una cantidad de items desde inventoty a stock por lote, item contiene el item de inventory el lote escogido y la cantidad de items
    // aplica para aquellos productos con solo lote y existencia
    // cuando se llama a esta mutation debe estar verificado que: el lote existe dentro de inventory 
    let item_stock = state.stock.find( (i) => i.reference == item.item.reference && i.id_ext1 == item.item.id_ext1)
    if (Boolean(item_stock)) {
      let lot = item_stock.batchs.find( (i) => i.batch == item.batch )
      // dentro de batchs: [ {batch:'', serials:[] }, ]
      if (Boolean(lot)) {
        lot.quantity += parseInt(item.lot_quantity)
      }
      else
        item_stock.batchs.push({batch: item.batch, serials: [], assurance: [], quantity: parseInt(item.lot_quantity)})
    }
    else {
      item_stock = JSON.parse(JSON.stringify(item.item))      
      item_stock.batchs = item_stock.batchs.filter( (i) => i.batch == item.batch )
      item_stock.batchs.map( (i) => i.quantity = parseInt(item.lot_quantity) )
      state.stock.push(item_stock)
      state.total_stock++
      saveState('total_stock', state.total_stock)
    }
    let lot = item.item.batchs.find( (i) => i.batch == item.batch )
      if (Boolean(lot)) {
        lot.quantity-=parseInt(item.lot_quantity)
      }

    state.inventory = state.inventory.filter( (i) => i.batchs.find( (c) => c.quantity > 0) )
    state.total_products = state.inventory.length
    saveState('total_products', state.total_products)

    state.total_stock_quantity = sumQuantityItems(state.stock)
    saveState('total_stock_quantity', state.total_stock_quantity)

    saveState('stock', state.stock)
    saveState('inventory', state.inventory)
  },
  MOVE_OWN_INVENTORY_ITEM_TO_OWN_STOCK_BY_LOTE(state, item) { 
    console.log("🅿️ into MOVE_OWN_INVENTORY_ITEM_TO_OWN_STOCK_BY_LOTE")
    let item_stock = null
    let item_inventory = null
    let lot = null
    if (Boolean(item.item)) {
      if(item.item.id_ext1){
        item_stock = state.own_stock.find( (i) => i.item.reference == item.item.reference && i.item.id_ext1 == item.item.id_ext1)
        item_inventory = state.own_inventory.find( (i) => i.reference == item.item.reference && i.id_ext1 == item.item.id_ext1)
      }

      if(item.item.id_ext){
        item_stock = state.own_stock.find( (i) => i.item.reference == item.item.reference && i.item.id_ext == item.item.id_ext)
        item_inventory = state.own_inventory.find( (i) => i.reference == item.item.reference && i.id_ext == item.item.id_ext)
      }

      if (Boolean(item_inventory)) {
        item_inventory.status = true;
      }
    }

    // ? preguntamos: ¿si el item ya fue creado (existe) dentro del stock?
    if (Boolean(item_stock)) {
      // ! El item existe, ya fue creado

      // * buscamos dentro de el item si existe el lote
      lot = item_stock.item.batchs.find( (i) => i.batch == item.batch )

      // ? preguntamos: ¿si ya fue creado (existe) el lote?
      if (Boolean(lot)) {
        // ! El lote existe, ya fue creado

        // * agregamos el serial y la fecha de garantía al lote del item
        if(lot.assurance.length>0) lot.assurance.push(
          item.item.batchs.find( (l) => l.batch == lot.batch)
            .assurance.find( (a, index) => item.assurance == index)
          )
        lot.count+=item.count
      }
      else {
        // ! El lote no existe

        // * agregamos el lote con el serial y su fecha de garantía al item
        item_stock.batchs.push({
          batch: item.batch, 
          serials: [], 
          assurance: [
            item.item.batchs.find( (l) => l.batch == item.batch).assurance.find( (a, index) => item.assurance == index)
            ],
          quantity: null,
          count:item.count
        })
      }
    }
    else {
      if(!item.item.id_ext1)item_stock = state.own_stock.find( (i) => i.item.reference == item.item.reference)
      if(Boolean(item_stock)){
        lot = item_stock.item.batchs.find( (i) => i.batch == item.batch )
        if (Boolean(lot)) {
          lot.count+=item.count
        }
      } else{

        item_stock = JSON.parse(JSON.stringify(item))   
        if(item_stock.assurance && item_stock.item.id_ext1){
          item_stock.item.batchs.map( (i) => i.assurance = i.assurance.filter( (a, index) => index == item.assurance))
          item_stock.item.batchs.map( (i) => i.count = 0)
          item_stock.item.batchs.forEach((batch) => {
            if (batch.serials.includes(item.serial)) {
              batch.count = item.count;
            }
          });
        }
        if(item_stock.item.id_ext){
          item_stock.item.batchs.map( (i) => i.count = 0)
          item_stock.item.batchs.forEach((batch) => {
            if (batch.batch==item.serial) {
              batch.count = item.count;
            }
          });
        }
        item_stock.user=JSON.parse(window.localStorage.getItem('auth.currentSession')).user.email

        state.own_stock.push(item_stock)
        state.own_total_stock++
      }
      saveState('own_total_stock', state.own_total_stock)
    }
    
    state.own_total_stock_quantity = sumQuantityOwnItems(state.own_stock)
    saveState('own_total_stock_quantity', state.own_total_stock_quantity)

    // * Guardamos cambios
    saveState('own_stock', state.own_stock)
    saveState('own_inventory', state.own_inventory)
  },
  MOVE_STOCK_ITEM_TO_INVENTORY_BY_LOTE(state, item ) { 
    console.log("🅿️ into MOVE_STOCK_ITEM_TO_INVENTORY_BY_LOTE")

    let item_inventory = state.inventory.find( (i) => i.reference == item.item.reference && i.id_ext1 == item.item.id_ext1)
    if (Boolean(item_inventory)) {
      let lot = item_inventory.batchs.find( (i) => i.batch == item.batch )
      if (Boolean(lot)) {
        lot.quantity += parseInt(item.lot_quantity)
      }
      else
        item_inventory.batchs.push({batch: item.batch, serials: [], assurance: [], quantity: parseInt(item.lot_quantity)})
    }
    else {
      item_inventory = JSON.parse(JSON.stringify(item.item))      
      item_inventory.batchs = item_inventory.batchs.filter( (i) => i.batch == item.batch )
      item_inventory.batchs.map( (i) => i.quantity = parseInt(item.lot_quantity) )
      state.inventory.push(item_inventory)
      state.total_products++
      saveState('total_products', state.total_products)
    }
    let lot = item.item.batchs.find( (i) => i.batch == item.batch )
      if (Boolean(lot)) {
        lot.quantity-=parseInt(item.lot_quantity)
      }

    state.stock = state.stock.filter( (i) => i.batchs.find( (c) => c.quantity > 0) )
    state.total_stock = state.stock.length
    saveState('total_stock', state.total_stock)

    state.total_stock_quantity = sumQuantityItems(state.stock)
    saveState('total_stock_quantity', state.total_stock_quantity)
    
    saveState('stock', state.stock)
    saveState('inventory', state.inventory)
  },
  MOVE_OWN_STOCK_ITEM_TO_OWN_INVENTORY_BY_LOTE(state, item ) { 
    console.log("🅿️ into MOVE_OWN_STOCK_ITEM_TO_OWN_INVENTORY_BY_LOTE")

    let item_inventory = state.own_inventory.find( (i) => i.reference == item.item.reference && i.id_ext1 == item.item.id_ext1)
    if (Boolean(item_inventory)) {
      let lot = item_inventory.batchs.find( (i) => i.batch == item.batch )
      if (Boolean(lot)) {
        lot.quantity += parseInt(item.lot_quantity)
      }
      else
        item_inventory.batchs.push({batch: item.batch, serials: [], assurance: [], quantity: parseInt(item.lot_quantity)})
    }
    else {
      item_inventory = JSON.parse(JSON.stringify(item.item))      
      item_inventory.batchs = item_inventory.batchs.filter( (i) => i.batch == item.batch )
      item_inventory.batchs.map( (i) => i.quantity = parseInt(item.lot_quantity) )
      state.own_inventory.push(item_inventory)
      state.own_total_products++
      saveState('own_total_products', state.own_total_products)
    }
    let lot = item.item.batchs.find( (i) => i.batch == item.batch )
      if (Boolean(lot)) {
        lot.quantity-=parseInt(item.lot_quantity)
      }

    state.own_stock = state.own_stock.filter( (i) => i.batchs.find( (c) => c.quantity > 0) )
    state.own_total_stock = state.own_stock.length
    saveState('own_total_stock', state.own_total_stock)

    state.own_total_stock_quantity = sumQuantityItems(state.own_stock)
    saveState('own_total_stock_quantity', state.own_total_stock_quantity)
    
    saveState('own_stock', state.own_stock)
    saveState('own_inventory', state.own_inventory)
  },

  MOVE_INVENTORY_ITEM_TO_PENDING_BY_SERIAL(state, item ) {
    console.log("🅿️ into MOVE_INVENTORY_ITEM_TO_PENDING_BY_SERIAL", item)
    let item_pending = null
    try {
      item_pending = state.pending.find( (i) => i.reference == item.item.reference && i.id_ext1 == item.item.id_ext1)
    } catch(err){
      console.error("not reference", item)
    }
    if (Boolean(item_pending)) {
      let lot = item_pending.batchs.find( (i) => i.batch == item.batch )
      if (Boolean(lot)) {
        lot.serials.push(item.serial)
        console.warn("*** serials_length:", lot.serials.length)
        lot.assurance.push(
          item.item.batchs.find( (l) => l.batch == lot.batch)
            .assurance.find( (a, index) => item.assurance == index)
          )
        lot.quantity++
        removeBatchFromInventory(item, 'serial', 'existant_batch')
      }
      else {
        let _batch = item.item.batchs.find( (l) => l.batch == item.batch)
        item_pending.batchs.push({
          batch: item.batch, 
          serials: [item.serial], 
          assurance: [
            _batch ? _batch.assurance.find( (a, index) => item.assurance == index) : ''
            ],
          quantity: 1
        })
        removeBatchFromInventory(item, 'serial', 'new_batch')
      }
      
    }
    else {
      try {
        item_pending = JSON.parse(JSON.stringify(item.item))      
        item_pending.batchs = item_pending.batchs.filter( (i) => i.batch == item.batch )
        item_pending.batchs.map( (i) => i.serials = i.serials.filter( (s) => s == item.serial  ) )
        item_pending.batchs.map( (i) => i.assurance = i.assurance.filter( (a, index) => index == item.assurance))
        item_pending.batchs.map( (i) => i.quantity = 1 )
        state.pending.push(item_pending)
        removeBatchFromInventory(item, 'serial', 'new_item')
        state.total_pending = state.pending.length
        saveState('total_pending', state.total_pending)
        state.total_pending_quantity = sumQuantityItems(state.pending)
        saveState('total_pending_quantity', state.total_pending_quantity)
      } catch(err) {
        console.error("error no valid JSON", item)
      }
    }
    // let lot = item.item.batchs.find( (i) => i.batch == item.batch )
    // if (Boolean(lot)) {
    //   lot.serials = lot.serials.filter( (s) => s != item.serial )
    //   lot.assurance = lot.assurance.filter( (a, index) => index != item.assurance )
    //   lot.quantity--
    // }
    state.inventory = state.inventory.filter( (i) => i.batchs.find( (c) => c.quantity > 0) )
    state.total_products = state.inventory.length 
    saveState('total_products', state.total_products)

    saveState('pending', state.pending)
    saveState('inventory', state.inventory)
  },
  MOVE_OWN_INVENTORY_ITEM_TO_OWN_PENDING_BY_SERIAL(state, item ) {
    console.log("🅿️ into MOVE_OWN_INVENTORY_ITEM_TO_OWN_PENDING_BY_SERIAL", item)
    let item_pending = null
    try {
      item_pending = state.own_pending.find( (i) => i.reference == item.item.reference && i.id_ext1 == item.item.id_ext1)
    } catch(err){
      console.error("not reference", item)
    }
    if (Boolean(item_pending)) {
      let lot = item_pending.batchs.find( (i) => i.batch == item.batch )
      if (Boolean(lot)) {
        lot.serials.push(item.serial)
        console.warn("*** serials_length:", lot.serials.length)
        lot.assurance.push(
          item.item.batchs.find( (l) => l.batch == lot.batch)
            .assurance.find( (a, index) => item.assurance == index)
          )
        lot.quantity++
        removeBatchFromInventory(item, 'serial', 'existant_batch')
      }
      else {
        let _batch = item.item.batchs.find( (l) => l.batch == item.batch)
        item_pending.batchs.push({
          batch: item.batch, 
          serials: [item.serial], 
          assurance: [
            _batch ? _batch.assurance.find( (a, index) => item.assurance == index) : ''
            ],
          quantity: 1
        })
        removeBatchFromInventory(item, 'serial', 'new_batch')
      }
      
    }
    else {
      try {
        item_pending = JSON.parse(JSON.stringify(item.item))      
        item_pending.batchs = item_pending.batchs.filter( (i) => i.batch == item.batch )
        item_pending.batchs.map( (i) => i.serials = i.serials.filter( (s) => s == item.serial  ) )
        item_pending.batchs.map( (i) => i.assurance = i.assurance.filter( (a, index) => index == item.assurance))
        item_pending.batchs.map( (i) => i.quantity = 1 )
        state.own_pending.push(item_pending)
        removeBatchFromInventory(item, 'serial', 'new_item')
        state.own_total_pending = state.own_pending.length
        saveState('own_total_pending', state.own_total_pending)
        state.own_total_pending_quantity = sumQuantityItems(state.own_pending)
        saveState('own_total_pending_quantity', state.own_total_pending_quantity)
      } catch(err) {
        console.error("error no valid JSON", item)
      }
    }
    // let lot = item.item.batchs.find( (i) => i.batch == item.batch )
    // if (Boolean(lot)) {
    //   lot.serials = lot.serials.filter( (s) => s != item.serial )
    //   lot.assurance = lot.assurance.filter( (a, index) => index != item.assurance )
    //   lot.quantity--
    // }
    state.own_inventory = state.own_inventory.filter( (i) => i.batchs.find( (c) => c.quantity > 0) )
    state.own_total_products = state.own_inventory.length 
    saveState('own_total_products', state.own_total_products)

    saveState('own_pending', state.own_pending)
    saveState('own_inventory', state.own_inventory)
  },
  MOVE_INVENTORY_ITEM_TO_PENDING_BY_LOTE(state, item ) { 
    console.log("🅿️ into MOVE_INVENTORY_ITEM_TO_PENDING_BY_LOTE", item, item)

    // se pasa una cantidad de items desde inventoty a pending por lote, item contiene el item de inventory el lote escogido y la cantidad de items
    // aplica para aquellos productos con solo lote y existencia
    // cuando se llama a esta mutation debe estar verificado que: el lote existe dentro de inventory 
    let item_pending = state.pending.find( (i) => i.reference == item.item.reference && i.id_ext1 == item.item.id_ext1)
    if (Boolean(item_pending)) {
      let lot = item_pending.batchs.find( (i) => i.batch == item.batch )
      // dentro de batchs: [ {batch:'', serials:[] }, ]
      if (Boolean(lot)) {
        lot.quantity += parseInt(item.lot_quantity)
        removeBatchFromInventory(item, 'batch', 'existant_batch')
      }
      else
        item_pending.batchs.push({batch: item.batch, serials: [], assurance: [], quantity: parseInt(item.lot_quantity)})
        removeBatchFromInventory(item, 'batch', 'new_batch')
    }
    else {
      item_pending = JSON.parse(JSON.stringify(item.item))      
      item_pending.batchs = item_pending.batchs.filter( (i) => i.batch == item.batch )
      item_pending.batchs.map( (i) => i.quantity = parseInt(item.lot_quantity) )
      state.pending.push(item_pending)
      removeBatchFromInventory(item, 'batch', 'new_item')
      state.total_pending = state.pending.length
      saveState('total_pending', state.total_pending)
      state.total_pending_quantity = sumQuantityItems(state.pending)
      saveState('total_pending_quantity', state.total_pending_quantity)
    }
    let lot = item.item.batchs.find( (i) => i.batch == item.batch )
      if (Boolean(lot)) {
        lot.quantity-=parseInt(item.lot_quantity)
      }

    state.inventory = state.inventory.filter( (i) => i.batchs.find( (c) => c.quantity > 0) )
    state.total_products = state.inventory.length
    saveState('total_products', state.total_products)

    saveState('pending', state.pending)
    saveState('inventory', state.inventory)
  },
  MOVE_OWN_INVENTORY_ITEM_TO_OWN_PENDING_BY_LOTE(state, item ) { 
    console.log("🅿️ into MOVE_OWN_INVENTORY_ITEM_TO_OWN_PENDING_BY_LOTE", item, item)

    // se pasa una cantidad de items desde inventoty a pending por lote, item contiene el item de inventory el lote escogido y la cantidad de items
    // aplica para aquellos productos con solo lote y existencia
    // cuando se llama a esta mutation debe estar verificado que: el lote existe dentro de inventory 
    let item_pending = state.own_pending.find( (i) => i.reference == item.item.reference && i.id_ext1 == item.item.id_ext1)
    if (Boolean(item_pending)) {
      let lot = item_pending.batchs.find( (i) => i.batch == item.batch )
      // dentro de batchs: [ {batch:'', serials:[] }, ]
      if (Boolean(lot)) {
        lot.quantity += parseInt(item.lot_quantity)
        removeBatchFromInventory(item, 'batch', 'existant_batch')
      }
      else
        item_pending.batchs.push({batch: item.batch, serials: [], assurance: [], quantity: parseInt(item.lot_quantity)})
        removeBatchFromInventory(item, 'batch', 'new_batch')
    }
    else {
      item_pending = JSON.parse(JSON.stringify(item.item))      
      item_pending.batchs = item_pending.batchs.filter( (i) => i.batch == item.batch )
      item_pending.batchs.map( (i) => i.quantity = parseInt(item.lot_quantity) )
      state.own_pending.push(item_pending)
      removeBatchFromInventory(item, 'batch', 'new_item')
      state.own_total_pending = state.own_pending.length
      saveState('own_total_pending', state.own_total_pending)
      state.own_total_pending_quantity = sumQuantityItems(state.own_pending)
      saveState('own_total_pending_quantity', state.own_total_pending_quantity)
    }
    let lot = item.item.batchs.find( (i) => i.batch == item.batch )
      if (Boolean(lot)) {
        lot.quantity-=parseInt(item.lot_quantity)
      }

    state.own_inventory = state.own_inventory.filter( (i) => i.batchs.find( (c) => c.quantity > 0) )
    state.own_total_products = state.own_inventory.length
    saveState('own_total_products', state.own_total_products)

    saveState('own_pending', state.own_pending)
    saveState('own_inventory', state.own_inventory)
  },

  SET_SPENT(state, spent) {
    state.spent = spent
    saveState('spent', state.spent)
  },
  SET_TOTAL_SPENT(state, total_spent) {
    state.total_spent = total_spent
    saveState('total_spent', total_spent)
  },
  SET_TOTAL_SPENT_QUANTITY(state, total_spent_quantity) {
    state.total_spent_quantity = total_spent_quantity
    saveState('total_spent_quantity', total_spent_quantity)
  },
  CLEAR_SPENT(state) {
    state.spent = []
    saveState('spent', state.spent)
  },
  SET_PENDING(state) {
    // state.pending.push(...state.inventory.filter( (i) => i.batchs.find( (c) => c.quantity > 0) ))
    state.pending.push(...state.inventory)
    state.total_pending_quantity = sumQuantityItems(state.pending)
    saveState('pending', state.pending)
  },
  SET_TOTAL_PENDING(state, total_pending) {
    state.total_pending = total_pending
    saveState('total_pending', total_pending)
  },
  SET_OWN_TOTAL_PENDING(state, own_total_pending) {
    state.own_total_pending = own_total_pending
    saveState('own_total_pending', own_total_pending)
  },
  SET_TOTAL_PENDING_QUANTITY(state, total_pending_quantity) {
    state.total_pending_quantity = total_pending_quantity
    saveState('total_pending_quantity', total_pending_quantity)
  },
  SET_OWN_TOTAL_PENDING_QUANTITY(state, own_total_pending_quantity) {
    state.own_total_pending_quantity = own_total_pending_quantity
    saveState('own_total_pending_quantity', own_total_pending_quantity)
  },
  CLEAR_PENDING(state) {
    state.pending = []
    state.total_pending_quantity = 0
    saveState('pending', state.pending)
  },
  SET_PENDING_RESULTS(state) {
    state.pending_results = state.pending.filter( (i) => i.batchs.find( (c) => c.quantity > 0) )
    saveState('pending_results', state.pending_results)
  },
  SET_OWN_PENDING(state) {
    // state.pending.push(...state.inventory.filter( (i) => i.batchs.find( (c) => c.quantity > 0) ))
    state.own_pending.push(...state.own_inventory)
    state.own_total_pending_quantity = sumQuantityItems(state.own_pending)
    saveState('own_pending', state.own_pending)
  },
  SET_TOTAL_OWN_PENDING(state, own_total_pending) {
    state.own_total_pending = own_total_pending
    saveState('own_total_pending', own_total_pending)
  },
  SET_TOTAL_OWN_PENDING_QUANTITY(state, own_total_pending_quantity) {
    state.own_total_pending_quantity = own_total_pending_quantity
    saveState('own_total_pending_quantity', own_total_pending_quantity)
  },
  CLEAR_OWN_PENDING(state) {
    state.own_pending = []
    state.own_total_pending_quantity = 0
    saveState('own_pending', state.own_pending)
  },
  SET_OWN_PENDING_RESULTS(state) {
    state.own_pending_results = state.own_pending.filter( (i) => i.batchs.find( (c) => c.quantity > 0) )
    saveState('own_pending_results', state.own_pending_results)
  },
  MOVE_SPENT_ITEM_TO_PENDING_BY_SERIAL(state, item ) { 
    console.log("🅿️ into MOVE_SPENT_ITEM_TO_PENDING_BY_SERIAL")
    let item_pending = state.pending.find( (i) => i.reference == item.item.reference && i.id_ext1 == item.item.id_ext1)
    if (Boolean(item_pending)) {
      let lot = item_pending.batchs.find( (i) => i.batch == item.batch )
      if (Boolean(lot)) {
        lot.serials.push(item.serial)
        lot.assurance.push(
          item.item.batchs.find( (l) => l.batch == lot.batch)
            .assurance.find( (a, index) => item.assurance == index)
          )
        lot.quantity++
      }
      else {
        item_pending.batchs.push({batch: item.batch, serials: [item.serial], 
                                assurance: [ item.item.batchs.find( (l) => l.batch == item.batch).assurance.find( (a, index) => item.assurance == index) ], 
                                quantity: 1})
      }
    }
    else {
      item_pending = JSON.parse(JSON.stringify(item.item))      
      item_pending.batchs = item_pending.batchs.filter( (i) => i.batch == item.batch )
      item_pending.batchs.map( (i) => i.serials = i.serials.filter( (s) => s == item.serial  ) )
      item_pending.batchs.map( (i) => i.assurance = i.assurance.filter( (a, index) => index== item.assurance ) )
      item_pending.batchs.map( (i) => i.quantity = 1 )
      state.pending.push(item_pending)
      state.total_pending++
      saveState('total_pending', state.total_pending)
      state.total_pending_quantity = sumQuantityItems(state.pending)
      saveState('total_pending_quantity', state.total_pending_quantity)

    }
    let lot = item.item.batchs.find( (i) => i.batch == item.batch )
      if (Boolean(lot)) {
        lot.serials = lot.serials.filter( (s) => s != item.serial )
        lot.assurance = lot.assurance.filter( (a, index) => index != item.assurance )
        lot.quantity--
      }
    
    state.spent = state.spent.filter( (i) => i.batchs.find( (c) => c.quantity > 0) )
    state.total_spent = state.spent.length
    saveState('total_spent', state.total_spent)
    state.total_spent_quantity = sumQuantityItems(state.spent)
    saveState('total_spent_quantity', state.total_spent_quantity)

    /* Raramente si paso un item de pending a spent y viceversa se recrea en inventory con existencia 0 :/ */
    state.inventory = state.inventory.filter( (i) => i.batchs.find( (c) => c.quantity > 0) )
    state.total_products = state.inventory.length
    saveState('total_products', state.total_products)
    saveState('pending', state.pending)
    saveState('total_pending', state.pending.length)
    state.total_pending_quantity = sumQuantityItems(state.pending)
    saveState('total_pending_quantity', state.total_pending_quantity)
    saveState('spent', state.spent)
  },
  MOVE_PENDING_ITEM_TO_SPENT_BY_SERIAL(state, item ) {
    console.log("🅿️ into MOVE_PENDING_ITEM_TO_SPENT_BY_SERIAL", item)
    let item_spent = state.spent.find( (i) => i.reference == item.item.reference && i.id_ext1 == item.item.id_ext1)
    if (Boolean(item_spent)) {
      let lot = item_spent.batchs.find( (i) => i.batch == item.batch )
      if (Boolean(lot)) {
        lot.serials.push(item.serial)
        lot.assurance.push(
          item.item.batchs.find( (l) => l.batch == lot.batch)
            .assurance.find( (a, index) => item.assurance == index)
          )
        lot.quantity++
      }
      else
        item_spent.batchs.push({batch: item.batch, serials: [item.serial], assurance: [ item.item.batchs.find( (l) => l.batch == item.batch).assurance.find( (a, index) => item.assurance == index) ], quantity: 1})
    }
    else {
      item_spent = JSON.parse(JSON.stringify(item.item))      
      item_spent.batchs = item_spent.batchs.filter( (i) => i.batch == item.batch )
      item_spent.batchs.map( (i) => i.serials = i.serials.filter( (s) => s == item.serial  ) )
      item_spent.batchs.map( (i) => i.assurance = i.assurance.filter( (a, index) => index == item.assurance ) )
      if (item_spent.batchs[0].assurance.length === 0){
        item_spent.batchs[0].assurance = item.item.batchs[0].assurance.filter(x => x !== null && x !== undefined)
      }
      item_spent.batchs.map( (i) => i.quantity = 1 )
      state.spent.push(item_spent)
      state.total_spent++
      saveState('total_spent', state.total_spent)
    }
    let lot = item.item.batchs.find( (i) => i.batch == item.batch )
    if (Boolean(lot)) {
      lot.serials = lot.serials.filter( (s) => s != item.serial )
      lot.assurance = lot.assurance.filter( (a, index) => index != item.assurance )
      lot.quantity--
    }

    state.total_spent_quantity = sumQuantityItems(state.spent)
    saveState('total_spent_quantity', state.total_spent_quantity)

    state.pending = state.pending.filter( (i) => i.batchs.find( (c) => c.quantity > 0) )
    state.total_pending = state.pending.length
    saveState('total_pending', state.total_pending)
    state.total_pending_quantity = sumQuantityItems(state.pending)
    saveState('total_pending_quantity', state.total_pending_quantity)

    state.inventory = state.inventory.filter( (i) => i.batchs.find( (c) => c.quantity > 0) )
    state.total_products = state.inventory.length 
    saveState('total_products', state.total_products)

    saveState('pending', state.pending)
    saveState('spent', state.spent)
  },
  MOVE_SPENT_ITEM_TO_PENDING_BY_LOTE(state, item) { 
    console.log("🅿️ into MOVE_SPENT_ITEM_TO_PENDING_BY_LOTE")
    let item_pending = state.pending.find( (i) => i.reference == item.item.reference && i.id_ext1 == item.item.id_ext1)
    if (Boolean(item_pending)) {
      let lot = item_pending.batchs.find( (i) => i.batch == item.batch )
      if (Boolean(lot)) {
        lot.quantity += parseInt(item.lot_quantity)
      }
      else
        item_pending.batchs.push({batch: item.batch, serials: [], assurance: [], quantity: parseInt(item.lot_quantity)})
    }
    else {
      item_pending = JSON.parse(JSON.stringify(item.item))      
      item_pending.batchs = item_pending.batchs.filter( (i) => i.batch == item.batch )
      item_pending.batchs.map( (i) => i.quantity = parseInt(item.lot_quantity) )
      state.pending.push(item_pending)
      state.total_pending++
      saveState('total_pending', state.total_pending)
      state.total_pending_quantity = sumQuantityItems(state.pending)
      saveState('total_pending_quantity', state.total_pending_quantity)
    }
    let lot = item.item.batchs.find( (i) => i.batch == item.batch )
    if (Boolean(lot)) {
      lot.quantity-=parseInt(item.lot_quantity)
    }
    
    state.spent = state.spent.filter( (i) => i.batchs.find( (c) => c.quantity > 0) )
    state.total_spent = state.spent.length
    saveState('total_spent', state.total_spent)
    state.total_spent_quantity = sumQuantityItems(state.spent)
    saveState('total_spent_quantity', state.total_spent_quantity)

    state.inventory = state.inventory.filter( (i) => i.batchs.find( (c) => c.quantity > 0) )
    state.total_products = state.inventory.length 
    saveState('total_products', state.total_products)

    saveState('pending', state.pending)
    saveState('spent', state.spent)
  },
  MOVE_PENDING_ITEM_TO_SPENT_BY_LOTE(state, item) { 
    console.log("🅿️ into MOVE_PENDING_ITEM_TO_SPENT_BY_LOTE")
    let item_spent = state.spent.find( (i) => i.reference == item.item.reference && i.id_ext1 == item.item.id_ext1)
    if (Boolean(item_spent)) {
      let lot = item_spent.batchs.find( (i) => i.batch == item.batch )
      if (Boolean(lot)) {
        lot.quantity += parseInt(item.lot_quantity)
      }
      else
        item_spent.batchs.push({batch: item.batch, serials: [], assurance: [], quantity: parseInt(item.lot_quantity)})
    }
    else {
      item_spent = JSON.parse(JSON.stringify(item.item))      
      item_spent.batchs = item_spent.batchs.filter( (i) => i.batch == item.batch )
      item_spent.batchs.map( (i) => i.quantity = parseInt(item.lot_quantity) )
      state.spent.push(item_spent)
      state.total_spent++
      saveState('total_spent', state.total_spent)
      state.total_spent_quantity = sumQuantityItems(state.spent)
      saveState('total_spent_quantity', state.total_spent_quantity)
    }
    let lot = item.item.batchs.find( (i) => i.batch == item.batch )
      if (Boolean(lot)) {
        lot.quantity-=parseInt(item.lot_quantity)
      }

    state.pending = state.pending.filter( (i) => i.batchs.find( (c) => c.quantity > 0) )
    state.total_pending = state.pending.length
    saveState('total_pending', state.total_pending)
    state.total_pending_quantity = sumQuantityItems(state.pending)
    saveState('total_pending_quantity', state.total_pending_quantity)

    state.inventory = state.inventory.filter( (i) => i.batchs.find( (c) => c.quantity > 0) )
    state.total_products = state.inventory.length 
    saveState('total_products', state.total_products)

    saveState('pending', state.pending)
    saveState('spent', state.spent)
  },

  MOVE_PENDING_ITEM_TO_STOCK_BY_SERIAL(state, item) { 
    console.log("🅿️ into MOVE_PENDING_ITEM_TO_STOCK_BY_SERIAL")  
    let item_stock = state.stock.find( (i) => i.reference == item.item.reference && i.id_ext1 == item.item.id_ext1)
    if (Boolean(item_stock)) {
      let lot = item_stock.batchs.find( (i) => i.batch == item.batch )
      if (Boolean(lot)) {
        lot.serials.push(item.serial)
        lot.assurance.push(
          item.item.batchs.find( (l) => l.batch == lot.batch)
            .assurance.find( (a, index) => item.assurance == index)
          )
        lot.quantity++
      }
      else
        item_stock.batchs.push({batch: item.batch, serials: [item.serial], assurance: [ item.item.batchs.find( (l) => l.batch == item.batch).assurance.find( (a, index) => item.assurance == index) ], quantity: 1})
    }
    else {
      item_stock = JSON.parse(JSON.stringify(item.item))      
      item_stock.batchs = item_stock.batchs.filter( (i) => i.batch == item.batch )
      item_stock.batchs.map( (i) => i.serials = i.serials.filter( (s) => s == item.serial  ) )
      item_stock.batchs.map( (i) => i.assurance = i.assurance.filter( (a, index) => index == item.assurance ) )
      item_stock.batchs.map( (i) => i.quantity = 1 )
      state.stock.push(item_stock)
      state.total_stock++
      saveState('total_stock', state.total_stock)
    }
    let lot = item.item.batchs.find( (i) => i.batch == item.batch )
      if (Boolean(lot)) {
        lot.serials = lot.serials.filter( (s) => s != item.serial )
        lot.assurance = lot.assurance.filter( (a, index) => index != item.assurance )
        lot.quantity--
      }

    state.pending = state.pending.filter( (i) => i.batchs.find( (c) => c.quantity > 0) )
    state.total_pending = state.pending.length
    saveState('total_pending', state.total_pending)
    state.total_pending_quantity = sumQuantityItems(state.pending)
    saveState('total_pending_quantity', state.total_pending_quantity)

    state.inventory = state.inventory.filter( (i) => i.batchs.find( (c) => c.quantity > 0) )
    state.total_products = state.inventory.length 
    saveState('total_products', state.total_products)

    state.total_stock_quantity = sumQuantityItems(state.stock)
    saveState('total_stock_quantity', state.total_stock_quantity)

    saveState('stock', state.stock)
    saveState('pending', state.pending)
  },
  MOVE_OWN_PENDING_ITEM_TO_OWN_STOCK_BY_SERIAL(state, item) { 
    console.log("🅿️ into MOVE_OWN_PENDING_ITEM_TO_OWN_STOCK_BY_SERIAL")  
    let item_stock = state.own_stock.find( (i) => i.reference == item.item.reference && i.id_ext1 == item.item.id_ext1)
    if (Boolean(item_stock)) {
      let lot = item_stock.batchs.find( (i) => i.batch == item.batch )
      if (Boolean(lot)) {
        lot.serials.push(item.serial)
        lot.assurance.push(
          item.item.batchs.find( (l) => l.batch == lot.batch)
            .assurance.find( (a, index) => item.assurance == index)
          )
        lot.quantity++
      }
      else
        item_stock.batchs.push({batch: item.batch, serials: [item.serial], assurance: [ item.item.batchs.find( (l) => l.batch == item.batch).assurance.find( (a, index) => item.assurance == index) ], quantity: 1})
    }
    else {
      item_stock = JSON.parse(JSON.stringify(item.item))      
      item_stock.batchs = item_stock.batchs.filter( (i) => i.batch == item.batch )
      item_stock.batchs.map( (i) => i.serials = i.serials.filter( (s) => s == item.serial  ) )
      item_stock.batchs.map( (i) => i.assurance = i.assurance.filter( (a, index) => index == item.assurance ) )
      item_stock.batchs.map( (i) => i.quantity = 1 )
      state.own_stock.push(item_stock)
      state.own_total_stock++
      saveState('own_total_stock', state.own_total_stock)
    }
    let lot = item.item.batchs.find( (i) => i.batch == item.batch )
      if (Boolean(lot)) {
        lot.serials = lot.serials.filter( (s) => s != item.serial )
        lot.assurance = lot.assurance.filter( (a, index) => index != item.assurance )
        lot.quantity--
      }

    state.own_pending = state.own_pending.filter( (i) => i.batchs.find( (c) => c.quantity > 0) )
    state.own_total_pending = state.own_pending.length
    saveState('own_total_pending', state.own_total_pending)
    state.own_total_pending_quantity = sumQuantityItems(state.own_pending)
    saveState('own_total_pending_quantity', state.own_total_pending_quantity)

    state.own_inventory = state.own_inventory.filter( (i) => i.batchs.find( (c) => c.quantity > 0) )
    state.own_total_products = state.own_inventory.length 
    saveState('own_total_products', state.own_total_products)

    state.own_total_stock_quantity = sumQuantityItems(state.own_stock)
    saveState('own_total_stock_quantity', state.own_total_stock_quantity)

    saveState('own_stock', state.own_stock)
    saveState('own_pending', state.own_pending)
  },
  MOVE_PENDING_ITEM_TO_STOCK_BY_LOTE(state, item ) {
    console.log("🅿️ into MOVE_PENDING_ITEM_TO_STOCK_BY_LOTE")   
    let item_stock = state.stock.find( (i) => i.reference == item.item.reference && i.id_ext1 == item.item.id_ext1)
    if (Boolean(item_stock)) {
      let lot = item_stock.batchs.find( (i) => i.batch == item.batch )
      if (Boolean(lot)) {
        lot.quantity += parseInt(item.lot_quantity)
      }
      else
        item_stock.batchs.push({batch: item.batch, serials: [], assurance: [], quantity: parseInt(item.lot_quantity)})
    }
    else {
      item_stock = JSON.parse(JSON.stringify(item.item))      
      item_stock.batchs = item_stock.batchs.filter( (i) => i.batch == item.batch )
      item_stock.batchs.map( (i) => i.quantity = parseInt(item.lot_quantity) )
      state.stock.push(item_stock)
      state.total_stock++
      saveState('total_stock', state.total_stock)
    }
    let lot = item.item.batchs.find( (i) => i.batch == item.batch )
      if (Boolean(lot)) {
        lot.quantity-=parseInt(item.lot_quantity)
      }

    state.pending = state.pending.filter( (i) => i.batchs.find( (c) => c.quantity > 0) )
    state.total_pending = state.pending.length
    saveState('total_pending', state.total_pending)
    state.total_pending_quantity = sumQuantityItems(state.pending)
    saveState('total_pending_quantity', state.total_pending_quantity)

    state.inventory = state.inventory.filter( (i) => i.batchs.find( (c) => c.quantity > 0) )
    state.total_products = state.inventory.length 
    saveState('total_products', state.total_products)

    state.total_stock_quantity = sumQuantityItems(state.stock)
    saveState('total_stock_quantity', state.total_stock_quantity)

    saveState('stock', state.stock)
    saveState('pending', state.pending)
  },
  MOVE_OWN_PENDING_ITEM_TO_OWN_STOCK_BY_LOTE(state, item ) {
    console.log("🅿️ into MOVE_OWN_PENDING_ITEM_TO_OWN_STOCK_BY_LOTE")   
    let item_stock = state.own_stock.find( (i) => i.reference == item.item.reference && i.id_ext1 == item.item.id_ext1)
    if (Boolean(item_stock)) {
      let lot = item_stock.batchs.find( (i) => i.batch == item.batch )
      if (Boolean(lot)) {
        lot.quantity += parseInt(item.lot_quantity)
      }
      else
        item_stock.batchs.push({batch: item.batch, serials: [], assurance: [], quantity: parseInt(item.lot_quantity)})
    }
    else {
      item_stock = JSON.parse(JSON.stringify(item.item))      
      item_stock.batchs = item_stock.batchs.filter( (i) => i.batch == item.batch )
      item_stock.batchs.map( (i) => i.quantity = parseInt(item.lot_quantity) )
      state.own_stock.push(item_stock)
      state.own_total_stock++
      saveState('own_total_stock', state.own_total_stock)
    }
    let lot = item.item.batchs.find( (i) => i.batch == item.batch )
      if (Boolean(lot)) {
        lot.quantity-=parseInt(item.lot_quantity)
      }

    state.own_pending = state.own_pending.filter( (i) => i.batchs.find( (c) => c.quantity > 0) )
    state.own_total_pending = state.own_pending.length
    saveState('own_total_pending', state.own_total_pending)
    state.own_total_pending_quantity = sumQuantityItems(state.own_pending)
    saveState('own_total_pending_quantity', state.own_total_pending_quantity)

    state.own_inventory = state.own_inventory.filter( (i) => i.batchs.find( (c) => c.quantity > 0) )
    state.own_total_products = state.own_inventory.length 
    saveState('own_total_products', state.own_total_products)

    state.own_total_stock_quantity = sumQuantityItems(state.own_stock)
    saveState('own_total_stock_quantity', state.own_total_stock_quantity)

    saveState('own_stock', state.own_stock)
    saveState('own_pending', state.own_pending)
  },

  SET_LOADING_INVENTORY(state, status) {
    state.loading_inventory = status
  },
  SET_INVENTORY_COUNT_MODE(state, status) {
    state.inventory_count_mode = status
    saveState('inventory_count_mode', status)
  },
  SET_OWN_INVENTORY_COUNT_MODE(state, status) {
    state.own_inventory_count_mode = status
    saveState('own_inventory_count_mode', status)
  },
  SET_INVENTORY_COUNT_SPENT_PRODUCTS(state, status) {
    state.inventory_count_spent_products = status
    saveState('inventory_count_spent_products', status)
  },
  SET_OWN_INVENTORY_COUNT_SPENT_PRODUCTS(state, status) {
    state.own_inventory_count_spent_products = status
    saveState('own_inventory_count_spent_products', status)
  },
  SET_INVENTORY_COUNT_REVIEW(state, status) {
    state.inventory_count_review = status
    saveState('inventory_count_review', status)
  },
  SET_OWN_INVENTORY_COUNT_REVIEW(state, status) {
    state.own_inventory_count_review = status
    saveState('own_inventory_count_review', status)
  },
  SET_INVENTORY_ONLINE_MODE(state, status) {
    state.inventory_online_mode = status
    saveState('inventory_online_mode', status)
  },
  SET_OWN_INVENTORY_ONLINE_MODE(state, status) {
    state.own_inventory_online_mode = status
    saveState('own_inventory_online_mode', status)
  },
}

export const actions = {

  init({ state, dispatch }) {},

  sendOrder(context, content) {
    return axios.post(`${serverUrl}/APIv1/orders/`, content)
    .then((response) => {
      return response
    })
  },
  setWarehouseI({ commit }, warehouse_i){
    commit('SET_WAREHOUSE_I', warehouse_i)
  },
  setOwnWarehouseI({ commit }, own_warehouse_i){
    commit('SET_OWN_WAREHOUSE_I', own_warehouse_i)
  },
  clearWarehouseI({ commit } ){
    commit('CLEAR_WAREHOUSE_I', null)
  },
  clearOwnWarehouseI({ commit } ){
    commit('CLEAR_OWN_WAREHOUSE_I', null)
  },
  setUbicacionI({ commit }, ubication_i){
    commit('SET_UBICATION_I', ubication_i)
  },
  clearUbicationI({ commit } ){
    commit('CLEAR_UBICATION_I', null)
  },
  fetchInventory(context, query) {
    query = query || ''
    return axios.get(`${serverUrl}/APIv1/inventories/${query}`).then((response) => {
      const inventory = response.data
      return inventory
    })
  },
  fetchInventoryList(context, query) {
    query = query || ''
    return axios.get(`${serverUrl}/APIv1/inventories_list/${query}`).then((response) => {
      const inventory = response.data
      return inventory
    })
  },
  fetchOwnInventories(context, query) {
    query = query || ''
    return axios.get(`${serverUrl}/APIv1/own_inventories/${query}`).then((response) => {
      const own_inventories = response.data
      return own_inventories
    })
  },
  fetchOwnInventoryReport(context, query) {
    return axios.get(`${serverUrl}/APIv1/own_inventories/get_report/${query}`, { responseType: 'arraybuffer' }).then((response) => {
      return response
    })
  },
  setInventory({ commit } , inventory) {
    commit('SET_INVENTORY', inventory)
  },
  setOwnInventory({ commit } , own_inventory) {
    commit('SET_OWN_INVENTORY', own_inventory)
  },
  setTotalProducts({ commit } , total_products) {
    commit('SET_TOTAL_PRODUCTS', total_products)
  },
  setOwnTotalProducts({ commit } , own_total_products) {
    commit('SET_OWN_TOTAL_PRODUCTS', own_total_products)
  },
  setTotalProductsQuantity({ commit } , total_products_quantity) {
    commit('SET_TOTAL_PRODUCTS_QUANTITY', total_products_quantity)
  },
  setOwnTotalProductsQuantity({ commit } , own_total_products_quantity) {
    commit('SET_OWN_TOTAL_PRODUCTS_QUANTITY', own_total_products_quantity)
  },
  clearInventory( { commit } ) {
    commit('CLEAR_INVENTORY')
  },
  clearOwnInventory( { commit } ) {
    commit('CLEAR_OWN_INVENTORY')
  },
  setStock({ commit } , stock ) {
    commit('SET_STOCK', stock)
  },
  setOwnStock({ commit } , own_stock ) {
    commit('SET_OWN_STOCK', own_stock)
  },
  setTotalStock({ commit } , total_stock ) {
    commit('SET_TOTAL_STOCK', total_stock)
  },
  setOwnTotalStock({ commit } , own_total_stock ) {
    commit('SET_OWN_TOTAL_STOCK', own_total_stock)
  },
  setTotalStockQuantity({ commit } , total_stock_quantity ) {
    commit('SET_TOTAL_STOCK_QUANTITY', total_stock_quantity)
  },
  setOwnTotalStockQuantity({ commit } , own_total_stock_quantity ) {
    commit('SET_OWN_TOTAL_STOCK_QUANTITY', own_total_stock_quantity)
  },
  clearStock( { commit } ) {
    commit('CLEAR_STOCK')
  },
  clearOwnStock( { commit } ) {
    commit('CLEAR_OWN_STOCK')
  },

  addItemInStockBySerial({ commit }, item ) {
    commit('MOVE_INVENTORY_ITEM_TO_STOCK_BY_SERIAL', item )
  },
  removeItemInStockBySerial({ commit }, item) {
    commit('MOVE_STOCK_ITEM_TO_INVENTORY_BY_SERIAL', item)
  },
  addItemInStockByLote({ commit }, item ) {
    commit('MOVE_INVENTORY_ITEM_TO_STOCK_BY_LOTE', item)
  },
  removeItemInStockByLote({ commit }, item ) {
    commit('MOVE_STOCK_ITEM_TO_INVENTORY_BY_LOTE', item)
  },
  
  addItemInOwnStockBySerial({ commit }, item ) {
    commit('MOVE_OWN_INVENTORY_ITEM_TO_OWN_STOCK_BY_SERIAL', item )
  },
  removeItemInOwnStockBySerial({ commit }, item) {
    commit('MOVE_OWN_STOCK_ITEM_TO_OWN_INVENTORY_BY_SERIAL', item)
  },
  addItemInOwnStockByLote({ commit }, item ) {
    commit('MOVE_OWN_INVENTORY_ITEM_TO_OWN_STOCK_BY_LOTE', item)
  },
  removeItemInOwnStockByLote({ commit }, item ) {
    commit('MOVE_OWN_STOCK_ITEM_TO_OWN_INVENTORY_BY_LOTE', item)
  },

  moveItemInInventoryToPendingkBySerial({ commit }, item ) {
    commit('MOVE_INVENTORY_ITEM_TO_PENDING_BY_SERIAL', item )
  },
  moveItemInInventoryToPendingByLote({ commit }, item ) {
    commit('MOVE_INVENTORY_ITEM_TO_PENDING_BY_LOTE', item)
  },

  moveItemInOwnInventoryToOwnPendingkBySerial({ commit }, item ) {
    commit('MOVE_OWN_INVENTORY_ITEM_TO_OWN_PENDING_BY_SERIAL', item )
  },
  moveItemInOwnInventoryToOwnPendingByLote({ commit }, item ) {
    commit('MOVE_OWN_INVENTORY_ITEM_TO_OWN_PENDING_BY_LOTE', item)
  },

  setSpent({ commit }, spent) {
    commit('SET_SPENT', spent)
  },
  setTotalSpent({ commit } , total_spent) {
    commit('SET_TOTAL_SPENT', total_spent)
  },
  setTotalSpentQuantity({ commit } , total_spent_quantity) {
    commit('SET_TOTAL_SPENT_QUANTITY', total_spent_quantity)
  },
  clearSpent( { commit }) {
    commit('CLEAR_SPENT' )
  },
  setPending({ commit }) {
    commit('SET_PENDING')
  },
  getTotalPendingQuantity(context) {
    return sumQuantityItems(state.pending)
  },
  getOwnTotalPendingQuantity(context) {
    return sumQuantityItems(state.own_pending)
  },
  setTotalPending({ commit } , total_pending) {
    commit('SET_TOTAL_PENDING', total_pending)
  },
  setOwnTotalPending({ commit } , own_total_pending) {
    commit('SET_OWN_TOTAL_PENDING', own_total_pending)
  },
  setTotalPendingQuantity({ commit } , total_pending_quantity) {
    commit('SET_TOTAL_PENDING_QUANTITY', total_pending_quantity)
  },
  setOwnTotalPendingQuantity({ commit } , own_total_pending_quantity) {
    commit('SET_OWN_TOTAL_PENDING_QUANTITY', own_total_pending_quantity)
  },
  clearPending( { commit } ) {
    commit('CLEAR_PENDING')
  },
  clearOwnPending( { commit } ) {
    commit('CLEAR_OWN_PENDING')
  },
  setPendingResults({ commit }) {
    commit('SET_PENDING_RESULTS')
  },
  setOwnPendingResults({ commit }) {
    commit('SET_OWN_PENDING_RESULTS')
  },
  addItemInSpentBySerial({ commit }, item) {
    commit('MOVE_PENDING_ITEM_TO_SPENT_BY_SERIAL', item)
  },
  removeItemInSpentBySerial({ commit }, item ) {
    commit('MOVE_SPENT_ITEM_TO_PENDING_BY_SERIAL', item )
  },
  addItemInSpentByLote({ commit }, item ) {
    commit('MOVE_PENDING_ITEM_TO_SPENT_BY_LOTE', item)
  },
  removeItemInSpentByLote({ commit }, item ) {
    commit('MOVE_SPENT_ITEM_TO_PENDING_BY_LOTE', item)
  },
  moveItemPendingToStockBySerial({ commit }, item ) {
    commit('MOVE_PENDING_ITEM_TO_STOCK_BY_SERIAL', item)
  },
  moveItemPendingToStockByLote({ commit }, item ) {
    commit('MOVE_PENDING_ITEM_TO_STOCK_BY_LOTE', item)
  },
  moveItemOwnPendingToOwnStockBySerial({ commit }, item ) {
    commit('MOVE_OWN_PENDING_ITEM_TO_OWN_STOCK_BY_SERIAL', item)
  },
  moveItemOwnPendingToOwnStockByLote({ commit }, item ) {
    commit('MOVE_OWN_PENDING_ITEM_TO_OWN_STOCK_BY_LOTE', item)
  },

  setLoadingInventory( { commit }, status ) {
    commit('SET_LOADING_INVENTORY', status)
  },

  enableInventoryCountMode( { commit } ) {
    commit('SET_INVENTORY_COUNT_MODE', true)
  },
  enableOwnInventoryCountMode( { commit } ) {
    commit('SET_OWN_INVENTORY_COUNT_MODE', true)
  },
  disableInventoryCountMode( { commit } ) {
    commit('SET_INVENTORY_COUNT_MODE', false)
  },
  disableOwnInventoryCountMode( { commit } ) {
    commit('SET_OWN_INVENTORY_COUNT_MODE', false)
  },

  enableInventoryCountSpentProducts( { commit } ) {
    commit('SET_INVENTORY_COUNT_SPENT_PRODUCTS', true)
  },
  disableInventoryCountSpentProducts( { commit } ) {
    commit('SET_INVENTORY_COUNT_SPENT_PRODUCTS', false)
  },
  enableOwnInventoryCountSpentProducts( { commit } ) {
    commit('SET_OWN_INVENTORY_COUNT_SPENT_PRODUCTS', true)
  },
  disableOwnInventoryCountSpentProducts( { commit } ) {
    commit('SET_OWN_INVENTORY_COUNT_SPENT_PRODUCTS', false)
  },

  enableInventoryCountReview( { commit } ) {
    commit('SET_INVENTORY_COUNT_REVIEW', true)
  },
  disableInventoryCountReview( { commit } ) {
    commit('SET_INVENTORY_COUNT_REVIEW', false)
  },
  setInventoryCountReview( { commit }, status ) {
    commit('SET_INVENTORY_COUNT_REVIEW', status)
  },
  enableOwnInventoryCountReview( { commit } ) {
    commit('SET_OWN_INVENTORY_COUNT_REVIEW', true)
  },
  disableOwnInventoryCountReview( { commit } ) {
    commit('SET_OWN_INVENTORY_COUNT_REVIEW', false)
  },
  setOwnInventoryCountReview( { commit }, status ) {
    commit('SET_OWN_INVENTORY_COUNT_REVIEW', status)
  },

  setInventoryOnlineMode( { commit }, status ) {
    commit('SET_INVENTORY_ONLINE_MODE', status)
  },
  setOwnInventoryOnlineMode( { commit }, status ) {
    commit('SET_OWN_INVENTORY_ONLINE_MODE', status)
  },
  sendEmail(context, content) {
    return axios.post(`${serverUrl}/APIv1/inventories/email_send/${content.query}`, content.body).then((response) => {
      return response
    }) 
  },
  fetchInventoryReport(context, query) {
    return axios.get(`${serverUrl}/APIv1/inventories/${query}`, { responseType: 'arraybuffer' }).then((response) => {
      return response
    })
  },
  fetchOwnStock(context, own_warehouse_selected) {
    return axios.get(`${serverUrl}/APIv1/own_inventories/get_stock/?id_warehouse=${own_warehouse_selected.id}`).then((response) => {
      return response.data
    })
  },
  saveOwnInventory(context, content) {
    return axios.post(`${serverUrl}/APIv1/own_inventories/save/`, content).then((response) => {
      return response
    }) 
  },
  finishOwnInventory(context, content) {
    return axios.post(`${serverUrl}/APIv1/own_inventories/finish/`, content).then((response) => {
      return response
    }) 
  },
}

// ===
// Private helpers
// ===

function getSavedState(key) {
  return JSON.parse(window.localStorage.getItem(key))
}

function saveState(key, state) {
  window.localStorage.setItem(key, JSON.stringify(state))
}